<template>
  <div id="app">
    <el-container>
      <el-header class="head-mobile">
        <!-- 企业logo -->
        <div class="nav-left">
          <div class="logo-box">
            <img src="./assets/img/toplogo.png" class="img-logo" alt="logo" />
          </div>
          <div class="nav-left-contact">
            <div class="nav-right-phone">
              <span>0755-88608260</span>
              <span>19842675889</span>
            </div>
          </div>
        </div>

        <div class="phone-menu-box" @click="handleClick">
          <i class="el-icon-close" v-show="phoneMenu"></i>
          <i class="el-icon-menu" v-show="!phoneMenu"></i>
        </div>

        <div class="mobile-menu" :class="{ 'mobile-menu-active': phoneMenu }">
          <ul class="menu-list">
            <li class="menu-item">
              <router-link to="/" @click.native="handleClick">
                <span>首页</span>
                <i class="el-icon-s-home"></i>
              </router-link>
            </li>
            <li class="menu-item">
              <router-link to="/product" @click.native="handleClick">
                <span>业务介绍</span>
                <i class="el-icon-s-goods"></i>
              </router-link>
            </li>
            <li class="menu-item">
              <router-link to="/caseList" @click.native="handleClick">
                <span>服务案例</span>
                <i class="el-icon-s-cooperation"></i>
              </router-link>
            </li>
            <li class="menu-item">
              <router-link to="/news" @click.native="handleClick">
                <span>新闻资讯</span>
                <i class="el-icon-news"></i>
              </router-link>
            </li>
            <li class="menu-item">
              <router-link to="/goin" @click.native="handleClick">
                <span>走进达通源</span>
                <i class="el-icon-office-building"></i>
              </router-link>
            </li>
          </ul>
        </div>


        <!-- <div class="pc"> -->
          <div class="logo">
            <img src="./assets/img/toplogo.png" alt />
          </div>
          <el-menu
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/product">业务介绍</el-menu-item>
            <el-menu-item index="/caseList">服务案例</el-menu-item>
            <el-menu-item index="/news">新闻资讯</el-menu-item>
            <el-menu-item index="/goin">走进达通源</el-menu-item>
          </el-menu>
        <!-- </div> -->
        
      </el-header>
      <!-- <levitatedSphere
      :itemHeight='120'
      :itemWidth='120'
      :gapWidthHide='80'
      :hideWidth='200'
      ></levitatedSphere> -->
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <div class="content-left">
            <div class="footer-section">
              <h3>关于我们</h3>
              <ul class="info-list">
                <li>
                  <i class="el-icon-s-goods"></i>
                  <router-link to="/product">业务介绍</router-link>
                </li>
                <li>
                  <i class="el-icon-s-cooperation"></i>
                  <router-link to="/caseList">服务案例</router-link>
                </li>
                <li>
                  <i class="el-icon-office-building"></i>
                  <router-link to="/goin">走进达通源</router-link>
                </li>
              </ul>
            </div>
            
            <div class="footer-section" style="margin-left: 6vw;">
              <h3>联系方式</h3>
              <div class="contact-info">
                <div class="phone">
                  <i class="el-icon-phone"></i>
                  0755-88608260
                </div>
                <div class="phone">
                  <i class="el-icon-mobile-phone"></i>
                  19842675889
                </div>
                <div class="address">
                  <i class="el-icon-location"></i>
                  深圳市光明区公明街道上村社区长春北路1A栋301
                </div>
              </div>
            </div>
            
            <div class="footer-section" style="margin-left: 6vw;">
              <h3>服务时间</h3>
              <ul class="info-list">
                <li>
                  <i class="el-icon-time"></i>
                  工作日：9:00 - 18:00
                </li>
                <li>
                  <i class="el-icon-message"></i>
                  24小时在线咨询
                </li>
              </ul>
            </div>
          </div>
          
          <div class="content-right">
            <div class="qrcode">
              <img src="./assets/img/ercode.jpg" alt="微信二维码" />
            </div>
            <div class="qrcode-text">扫码关注公众号</div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import MapContainer from "@/components/MapContainer.vue";
import levitatedSphere from "./components/levitatedSphere.vue";
export default {
  components: {
    levitatedSphere,
    MapContainer
  },
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      //mobile
      currentIndex: null,
      phoneMenu: false,
      mobileMenu: [
        { title: "首页", href: "/" },
        { title: "业务介绍", href: "/product" },
        { title: "服务案例", href: "/caseList" },
        { title: "新闻资讯", href: "/news" },
        { title: "走进达通源", href: "/goin" }
      ],
    };
  },
  methods: {
    translatePage(path) {
    const STORE_PATH='translateStorePath:'
    const SELECTORS = 'p,span, div, h1, h2, h3, h4, h5, h6, li, a, caption, button, th, td';
    const SKIP_ATTR = 'data-no-translate';
  
  // 优化元素收集逻辑
  // const elements = Array.from(document.querySelectorAll(SELECTORS))
  //   .filter(el => {
  //     if (el.hasAttribute(SKIP_ATTR)) return false;
  //     const text = el.textContent.trim();
  //     return text && 
  //            (el.offsetWidth || el.offsetHeight) &&
  //            el.childElementCount === 0 &&
  //            !this.isInputElement(el);
  //   });

  const elements = Array.from(document.querySelectorAll(SELECTORS))
  .filter(el => {
    if (el.hasAttribute(SKIP_ATTR)) return false;

    const text = el.textContent.trim();

    // 排除无内容或不可见的元素
    if (!text || (!el.offsetWidth && !el.offsetHeight)) return false;

    // 如果只包含 <br>，也允许
    const onlyBrChildren = Array.from(el.children).every(child => child.tagName === 'BR');
    if (el.children.length > 0 && !onlyBrChildren) return false;

    // 排除 input、textarea 等
    return !this.isInputElement(el);
  });

  if (elements.length === 0) return;

  let translateText=localStorage.getItem(STORE_PATH+path)
  if(translateText){
    let result=JSON.parse(translateText)
    elements.forEach((el, index) => {
      el.dataset.translated = true;  // 添加翻译标记
      el.textContent = result.translations[index];
    });
    return;
  }


  // 维持FormData格式
  const formData = new FormData();
  formData.append('target_lang', this.getTargetLanguage());
  formData.append('texts', JSON.stringify(elements.map(el => el.textContent.trim())));

  // 添加请求取消机制
  if (this.translateAbortController) {
    this.translateAbortController.abort();
  }
  this.translateAbortController = new AbortController();

  fetch('http://localhost:8000/translates', {
    method: 'POST',
    body: formData,
    signal: this.translateAbortController.signal
  })
  .then(response => {
    if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
    return response.json();
  })
  .then(result => {
    // if (result.translations?.length !== elements.length) {
    //   throw new Error('Translation count mismatch');
    // }
    
    elements.forEach((el, index) => {
      el.dataset.translated = true;  // 添加翻译标记
      el.textContent = result.translations[index];
    });
    localStorage.setItem(STORE_PATH+path,JSON.stringify(result))
  })
  .catch(error => {
    if (error.name !== 'AbortError') {
      console.error('Translation failed:', error);
      // 错误回退机制
      elements.forEach(el => el.textContent = el.dataset.originalText);
    }
  });
},
isInputElement(el) {
  return el.tagName === 'INPUT' || 
         el.tagName === 'TEXTAREA' ||
         el.isContentEditable;
},
getTargetLanguage() {
  // 可以从全局配置、用户设置或浏览器语言获取
  return  'de';
},
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      console.log(this.defaultActive);
    },
    clickRouter(url) {
      this.$router.push(url);
      this.phoneMenu=false
    },
    //mobile
    handleMobileMenu(href) {
    this.$router.push(href);
    this.phoneMenu=false
    },
    handleClick() {
      this.phoneMenu = !this.phoneMenu;
      this.$bus.$emit("phoneMenu", this.phoneMenu);
    }
  },
  watch: {
    '$route' (to, from) {
      console.log(to)
      // 每次路由变化时调用 translatePage
      setTimeout(() => {
        // this.translatePage(to.fullPath);
      }, 1500);
    }
  },
  mounted() {
    if (this.$route.name != "home") {
      this.isShow = true;
      this.defaultActive = "/" + this.$route.name;
    }
    this.phoneMenu=false
    // setTimeout((()=>{this.translatePage()}),1500)
    // this.translatePage()
  },
};
</script>

<style lang="scss">
@import url('./assets/css/global.css');
.el-icon-s-unfold-active{
  display: none !important;
}

.el-icon-close-active{
  display: block!important;
}
.mobile-menu {
    display: none;
    position: fixed;
    top: 14vw;
    right: 0;
    z-index: 999;
    width: 100%;
    height: calc(100vh - 14vw);
    background: #fff;
    
    .menu-list {
        padding: 4vw;
        list-style: none;
        margin: 0;
        text-align: right;
        
        .menu-item {
            margin-bottom: 3vw;
            border-bottom: 1px solid #f0f0f0;
            
            a {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 4vw;
                text-decoration: none;
                color: #333;
                font-size: 4.5vw;
                transition: all 0.3s ease;
                
                i {
                    font-size: 5vw;
                    margin-left: 4vw;
                    color: #3388ff;
                    order: 2;
                }
                
                span {
                    order: 1;
                }
                
                &.router-link-active {
                    color: #3388ff;
                    font-weight: bold;
                    background: rgba(51, 136, 255, 0.05);
                    
                    i {
                        color: #3388ff;
                    }
                }
            }

            &:last-child {
                border-bottom: none;
            }
        }
    }
}

.mobile-menu-active {
    display: block;
    animation: slideIn 0.3s ease-out forwards;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media screen and (min-width: 1600px) {
  .footer{
    .footer-content {
      max-width: 1300px!important;
    }
  }
}

@media screen and (max-width: 1000px) {
    .head-mobile {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 4vw;
        height: 14vw !important;
    }

    .nav-left {
        display: flex !important;
        width: 80% !important;
        height: 100% !important;
        align-items: center;
        
        .logo-box {
            width: 60%;
            height: 60%;
            
            .img-logo {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        
        .nav-left-contact {
            display: flex;
            align-items: center;
            margin-left: 16px;
            
            .nav-right-phone {
                display: flex;
                flex-direction: column;
                font-size: 3vw;
                font-weight: 600;
                padding-left: 16px;
                border-left: 2px solid #ebebeb;
                color: #3388ff;
            }
        }
    }
    
    .phone-menu-box {
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 10vw;
        height: 10vw;
        color: white;
        background: #3388ff;
        border-radius: 2vw;
        cursor: pointer;
        transition: all 0.3s ease;
        margin: auto 0;
        
        i {
            font-size: 5vw;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
        }
        
        &:hover {
            background: #1a6cd4;
        }
    }

    .el-menu-demo{
      display: none;
    }
    .logo{
      display: none;
    }
    .head-mobile{
      height: 14vw !important;
    }
    .nav-left{
      display: none;
    }
    .pc{
      display: none;
    }
}

.nav-left{
  display: none;
}
.link {
  text-decoration: none;
  color: black;
  font-weight: 600;
}
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  top: 0;
  left: 0;
  background: white;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .logo {
    width: 20vw;
    padding: 10px;
    img {
      width: 100%;
      height: auto;
      max-width: 100%;
    }
  }
}

.el-main {
  padding-top: 60px !important;
  background-color: var(--global-background-color);
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0!important;
}

.el-menu-item {
  font-size: 1.2vw!important;
  font-weight: 600;
}

.footer {
    background: #fff;
    padding: 2vw 0;
    position: relative;
    box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.05);

    .footer-content {
        max-width: 1100px;
        margin: 0 auto;
        padding: 0 3vw;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .content-left {
            display: flex;
            gap: 3vw;

            .footer-section {
                h3 {
                    font-size: 15px;
                    color: #333;
                    margin-bottom: 12px;
                    font-weight: 600;
                }

                .info-list {
                    list-style: none;
                    padding: 0;
                    margin: 0;

                    li {
                        margin-bottom: 8px;
                        font-size: 13px;
                        display: flex;
                        align-items: center;

                        i {
                            color: #3388ff;
                            margin-right: 6px;
                            font-size: 14px;
                        }

                        a {
                            color: #666;
                            text-decoration: none;
                            transition: all 0.3s ease;

                            &:hover {
                                color: #3388ff;
                            }
                        }
                    }
                }

                .contact-info {
                    .phone {
                        font-size: 13px;
                        color: #3388ff;
                        font-weight: 500;
                        margin-bottom: 8px;
                        display: flex;
                        align-items: center;

                        i {
                            margin-right: 6px;
                            font-size: 14px;
                        }
                    }

                    .address {
                        color: #666;
                        font-size: 13px;
                        display: flex;
                        align-items: flex-start;
                        line-height: 1.4;

                        i {
                            color: #3388ff;
                            margin-right: 6px;
                            margin-top: 3px;
                            font-size: 14px;
                        }
                    }
                }
            }
        }

        .content-right {
            text-align: center;
            margin-left: 2vw;

            .qrcode {
                width: 90px;
                height: 90px;
                padding: 4px;
                background: white;
                border: 1px solid #eee;
                border-radius: 4px;
                margin-bottom: 6px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }

            .qrcode-text {
                color: #666;
                font-size: 12px;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .footer {
        padding: 4vw 0;

        .footer-content {
            flex-direction: column;
            gap: 4vw;

            .content-left {
                flex-direction: column;
                gap: 3vw;
            }

            .content-right {
                margin-left: 0;
                margin-top: 2vw;

                .qrcode {
                    width: 80px;
                    height: 80px;
                }
            }
        }
    }
}

.phone-menu-box{
  display: none;
}

//mobile
/* 超小屏幕（手机，小于 768px） */
@media screen and (max-width: 1000px) {
  .phone-menu-box {
      display: flex !important;
      justify-content: center;
      align-items: center;
      width: 8vw;
      height: 8vw;
      color: white;
      background: #65a4b7;
      border-radius: 50%;

      .i-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: end;
        width: 16px;
        height: 18px;

        i {
          transition: all 0.4s ease-out;
          display: inline-block;
          height: 2px;
          background-color: #fff;
          margin: 2px 0;
          border-radius: 5px;
        }
      }

      & i:nth-child(2) {
        width: 11px;
      }

      & i:nth-child(3) {
        width: 16px;
      }
    }
}

    .nav-right {
      display: none;
    }

    .i-menu-active {
        .i-box {
        }

        // & i:nth-child(1) {
        //   transform: rotate(45deg);
        // }

        & i:nth-child(2) {
          opacity: 0;
        }

        & i:nth-child(3) {
          transform: rotate(-45deg);
        }
      }

@media screen and (min-width: 1000px) {
    .footer {
        .footer-content {
            .content-left {
                .footer-section {
                    h3 {
                        font-size: 20px;
                    }

                    .info-list li {
                        font-size: 16px;
                        
                        i {
                            font-size: 16px;
                        }
                    }

                    .contact-info {
                        .phone {
                            font-size: 16px;
                            
                            i {
                                font-size: 16px;
                            }
                        }
                        
                        .address {
                            font-size: 16px;
                            
                            i {
                                font-size: 16px;
                            }
                        }
                    }
                }
            }

            .content-right {
                .qrcode-text {
                    font-size: 15px;
                }
            }
        }
    }
}
</style>
